import { dataProps } from './properties'

export const setInventoryRackList = (state, payload) => {
    state.list = payload
}    

export const setInventoryRackData = (state, payload) => {
    state.props = payload
} 

export const resetInventoryRackData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryRack/mutations.js